var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.6242C2 8.41347 5.35786 5 9.5 5C13.6421 5 17 8.41347 17 12.6242C17 17.1801 12.7742 20.4742 10.1499 21.8399C9.73976 22.0534 9.26024 22.0534 8.85011 21.8399C6.22584 20.4742 2 17.1801 2 12.6242ZM9.5 15.7215C11.1108 15.7215 12.4167 14.3775 12.4167 12.7195C12.4167 11.0615 11.1108 9.71747 9.5 9.71747C7.88917 9.71747 6.58333 11.0615 6.58333 12.7195C6.58333 14.3775 7.88917 15.7215 9.5 15.7215Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.952 17.737C19.356 16.0422 22 13.228 22 9.6242C22 5.41347 18.6421 2 14.5 2C12.8173 2 11.2641 2.5633 10.0128 3.51452C14.7652 3.78434 18.5 7.78128 18.5 12.6242C18.5 14.5699 17.8639 16.2866 16.952 17.737Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholders);
export default __webpack_public_path__ + "static/media/placeholders.07d18d2896b6e1f9d5c9f9486b259d73.svg";
export { ForwardRef as ReactComponent };